<template>
  <router-view></router-view>
</template>

<script>
export default {
}
</script>

<style lang="scss">
.el-table {
  width: calc(100vw - 270px) !important;
}

</style>
